<script setup>
import { useI18n } from 'vue-i18n'
import TitleComponent from "@/components/TitleComponent/index.vue"
const { t } = useI18n();
import { useRouter } from 'vue-router'
const router = useRouter()
const goBack = () => {
    router.go(-1);
}
const isMobile=ref(false);//false代表pc
onMounted(() => { 
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log('Is mobile device:', isMobile.value);
 })
</script>
<template>
    <div class="container">
        <TitleComponent v-if="isMobile" :title="t('setup134')"></TitleComponent>

        <!-- <div class="topdiv" v-if="isMobile">
        <div class="top">
            <div @click="goBack()"><svg-icon icon-class="fanhui" /></div>
            <div>{{ $t('setup134') }}</div>
            <div></div>
        </div> -->
           
    <!-- </div> -->
        <div class="packContent">
            <div class="title">
                {{ $t('setup134') }}
            </div>
            <div class="Headline">{{ $t('setup291') }}</div>
            <div class="Subtitle">{{ $t('setup292') }}</div>
            <div class="content">
                <div class="Subtitle-content">{{ $t('setup290') }}</div>
                <div class="table">
                    <table width="100%" border="1"  cellspacing="0">
                        <tbody>
                        <tr>
                            <th>{{ $t('setup293') }}</th>
                            <th>{{ $t('setup294') }}</th>
                        </tr>
                        <tr>
                            <td>{{ $t('setup295') }}</td>
                                <td>{{ $t('setup296') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup297') }}</td>
                            <td>{{ $t('setup298') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup299') }}</td>
                            <td>{{ $t('setup300') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup301') }}</td>
                            <td>{{ $t('setup302') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup303') }}</td>
                            <td>{{ $t('setup304') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup305') }}</td>
                            <td>{{ $t('setup306') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup307') }}</td>
                            <td>{{ $t('setup308') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup309') }}</td>
                            <td>{{ $t('setup310') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup311') }}</td>
                            <td>{{ $t('setup312') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup313') }}</td>
                            <td>{{ $t('setup314') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup315') }}</td>
                            <td>{{ $t('setup314') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup316') }}</td>
                            <td>{{ $t('setup314') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup317') }}</td>
                            <td>{{ $t('setup314') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup318') }}</td>
                            <td>{{ $t('setup306') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup319') }}</td>
                            <td>{{ $t('setup306') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup320') }}</td>
                            <td>{{ $t('setup308') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup331') }}</td>
                            <td>{{ $t('setup308') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup332') }}</td>
                            <td>{{ $t('setup308') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup333') }}</td>
                            <td>{{ $t('setup308') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup334') }}</td>
                            <td>{{ $t('setup308') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup335') }}</td>
                            <td>{{ $t('setup306') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup336') }}</td>
                            <td>{{ $t('setup306') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup337') }}</td>
                            <td>{{ $t('setup302') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('setup338') }}</td>
                            <td>{{ $t('setup302') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang='scss'>
  .container{
        width: 100%;
    }
.title {
    padding-top: 0px;
    color: #282828;
    font-weight: 700;
    font-size: 25px;
    padding-bottom: 16px;
}

.Headline {
    padding: 8px 0px;
    font-size: 18px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}

.Subtitle {
    font-size: 14px;
    line-height: 30px;
    // overflow: hidden;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}

.content {
    padding: 60px 0 0 0;

    .Subtitle-content {
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;
    }
    .table{
        padding-bottom: 50px;
        table{
            border-collapse: collapse;
            border: 2px solid black;
        }
        th{
            border: 1 solid;
            border-color: #131926;
            color: #169179;
            padding: 10px 5px; 
        }
        td{
            border-width:1px;
            border: 1 solid;
            border-color: #131926;
            text-align: center;
            padding: 8px 5px; 
        }
    }
}
@media (max-width: 768px) {
    .container{
        width: 100%;
    }
    .content{
        padding-top: 0px;
    }
    .packContent{
        // padding: 0 20px 100px 20px;
        padding: 45px 20px 100px 20px;
        .title{
            display: none;
        }
    }
}
</style>